import { inject } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { catchError, map, Observable } from 'rxjs';
import {
    OrganizationState,
    SetCurrentStudyType,
    SetCurrentYear,
    StudyType,
} from '../../features/admin/organization/organization.state';
import { AuthState } from '../states/auth.state';
import { ConcessionControlStatus } from 'src/app/features/main/concessioncontrol/assets/constants';
import { CracStatus } from 'src/app/features/main/crac/assets/constants';
import { CracMapStatus } from 'src/app/features/main/cracmap/assets/constants';

export const yearStudyGuard: CanActivateFn = (
    next: ActivatedRouteSnapshot,
): Observable<boolean> | Promise<boolean> | boolean => {
    const router = inject(Router);
    const store = inject(Store);
    let year = next.params['year'];
    if (!year) {
        return false;
    }
    year = parseInt(year);

    const currentStudyType = next.data['studyType'] as StudyType;
    const currentOrganization = store.selectSnapshot(OrganizationState.currentOrganization);
    const isAdmin = store.selectSnapshot(AuthState.loggedUser)?.isAdmin;

    let availableYears: any[] | undefined = [];
    if (currentStudyType == StudyType.CC) {
        availableYears = currentOrganization?.concessionControls?.filter(
            (cc) => isAdmin || cc.status == ConcessionControlStatus.AVAILABLE,
        );
    } else if (currentStudyType == StudyType.CRAC) {
        availableYears = currentOrganization?.cracs?.filter(
            (crac) => isAdmin || crac.status == CracStatus.AVAILABLE,
        );
    } else if (currentStudyType == StudyType.CRACMAP) {
        availableYears = currentOrganization?.cracMaps?.filter(
            (cracmap) => isAdmin || cracmap.status == CracMapStatus.AVAILABLE,
        );
    }

    if (!availableYears?.find((study) => study.year == year)) {
        store.dispatch([new SetCurrentStudyType({ studyType: currentStudyType })]);
        return router.navigate([`/main/${isAdmin ? currentOrganization?.id : ''}`]);
    }
    return store
        .dispatch([
            new SetCurrentStudyType({ studyType: currentStudyType }),
            new SetCurrentYear({ year }),
        ])
        .pipe(
            map(() => true),
            catchError(() => {
                return router.navigate([`/main/${isAdmin ? currentOrganization?.id : ''}`]);
            }),
        );
};
